import getProductObject from '../utils/getProductJSON';

export function updatePromoAnnouncement(): void {
  const DISCOUNT_CODE_QUERY_PARAM_KEY = 'code';
  const AMOUNT_OFF_QUERY_PARAM_KEY = 'amount';
  const IS_PERCENTAGE_QUERY_PARAM_KEY = 'ispercentage';

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const alertToUpdate = document.querySelector('.alert-bar__text');

  if (urlParams && alertToUpdate) {
    const product = window.embark.shop.product || getProductObject();
    const promo_code = urlParams
      .get(DISCOUNT_CODE_QUERY_PARAM_KEY)
      ?.replace(/[^\w]/gi, '');
    const promo_amount = urlParams
      .get(AMOUNT_OFF_QUERY_PARAM_KEY)
      ?.replace(/[^\w]/gi, '');
    const is_percentage = urlParams
      .get(IS_PERCENTAGE_QUERY_PARAM_KEY)
      ?.replace(/[^\w]/gi, '')
      ?.toLowerCase();

    if (!promo_code || !promo_amount || !is_percentage || !product.title) {
      return;
    }

    const getAlertBarMarkup = (
      promoCode: string,
      promoAmount: string,
      productTitle: string
    ): string => {
      return `<p><strong>Use code ${promoCode} for ${promoAmount} off a ${productTitle}!</strong></p>`;
    };

    if (is_percentage === 'true') {
      alertToUpdate.innerHTML = getAlertBarMarkup(
        promo_code,
        `${promo_amount}%`,
        product.title
      );
    } else if (is_percentage === 'false') {
      alertToUpdate.innerHTML = getAlertBarMarkup(
        promo_code,
        `$${promo_amount}`,
        product.title
      );
    }
  }
}

export function setCustomTextOrPromo(): void {
  const isCustomBanner = document.querySelector(
    '[data-is-custom-banner="true"]'
  );

  if (!isCustomBanner) {
    updatePromoAnnouncement();
  }
}
